import 'css-chunksrc/client/scenes/workloads/detailsView/details/progress/styles.scss';export default {
  "details": "_details_15fyp_1",
  "list": "_list_15fyp_16",
  "block": "_block_15fyp_20",
  "calendar": "_calendar_15fyp_32",
  "text": "_text_15fyp_41",
  "project": "_project_15fyp_49",
  "closedCalendar": "_closedCalendar_15fyp_57"
};